import { produce } from 'immer';

import { SERVICELINK_FLOOD_PRODUCTS_ACTION_TYPE } from '../actions';

const initialState = {
  items: [],
};

const servicelinkFloodProductsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case SERVICELINK_FLOOD_PRODUCTS_ACTION_TYPE.GET_SERVICELINK_FLOOD_PRODUCTS:
        draft.items = payload || [];
        break;

      default:
        return state;
    }
  });

export default servicelinkFloodProductsReducer;
